import Start from "../views/assessment/start";
import AssessmentInfo from "../views/assessment/assessmentInfo";
import BehavioralAssessment from "../views/assessment/behavioralAssessment";
import CognitiveGame from "../views/assessment/cognitiveGame";
import AptitudeGame from "../views/assessment/aptitudeGame";
import RegistrationFields from "../views/assessment/registrationFields";
import LoginMethod from "../views/assessment/loginMethod";
import Artwork from "../views/assessment/artwork";
import Launch from "../views/assessment/launch";
import SelectionListing from "../views/assessment/selectionListing";
import Loading from "../views/assessment/loading";
import Congratulation from "../views/assessment/congratulation";
import Invitation from "../views/assessment/invitation";
import Dashboard from "../views/assessment/dashboard";
import MiniGames from "../views/assessment/miniGames";

const routes = [
    {
        path: "/info",
        name: "Assessment Information",
        component: AssessmentInfo,
        layout: "/assessment",
        display: true,
        root: false,
        type: "generic"
    },
    {
        path: "/behavioral",
        name: "Behavioral Assessment",
        component: BehavioralAssessment,
        layout: "/assessment",
        display: true,
        root: false,
        type: "generic"
    },
    {
        path: "/miniGames",
        name: "Mini Games",
        component: MiniGames,
        layout: "/assessment",
        display: true,
        root: false,
        type: "progress"
    },
    {
        path: "/cognitive",
        name: "Cognitive Game",
        component: CognitiveGame,
        layout: "/assessment",
        display: true,
        root: false,
        type: "ace"
    },
    {
        path: "/aptitude",
        name: "Aptitude Game",
        component: AptitudeGame,
        layout: "/assessment",
        display: true,
        root: false,
        type: "ace"
    },
    {
        path: "/registrationFields",
        name: "Registration Form Fields",
        component: RegistrationFields,
        layout: "/assessment",
        display: true,
        root: false,
        type: "generic"
    },
    {
        path: "/loginMethod",
        name: "Login Method",
        component: LoginMethod,
        layout: "/assessment",
        display: true,
        root: false,
        type: "generic"
    },
    {
        path: "/artWork",
        name: "Customize Artwork",
        component: Artwork,
        layout: "/assessment",
        display: true,
        root: false,
        type: "generic"
    },
    {
        path: "/launch",
        name: "Launch Date & Availability",
        component: Launch,
        layout: "/assessment",
        display: true,
        root: false,
        type: "generic"
    },
    {
        path: "/selection",
        name: "User Selection",
        component: SelectionListing,
        layout: "/assessment",
        display: false,
        root: true,
        type: "generic"
    },
    {
        path: "/loading",
        name: "Loading",
        component: Loading,
        layout: "/assessment",
        display: false,
        root: true,
        type: "generic"
    },
    {
        path: "/congratulation",
        name: "Congratulation",
        component: Congratulation,
        layout: "/assessment",
        display: false,
        root: true,
        type: "generic"
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        layout: "/assessment",
        display: false,
        root: true,
        type: "generic"
    },
    {
        path: "/invitation/:eventId",
        name: "Invitation",
        component: Invitation,
        layout: "/assessment",
        display: false,
        root: true,
        type: "generic"
    },
    {
        path: "/index",
        name: "Start",
        component: Start,
        layout: "/assessment",
        display: false,
        root: true,
        type: "generic"
    },
];

export default routes;